import ArticleLayout from '@/components/feature/ArticleLayout';

export default function PantsArticle() {
  return (
    <>
      <title>Superbuy Spreadsheet Pants &amp; Shorts: Bottom Wear Buying Guide for International Shoppers</title>
      <meta name="description" content="Complete Superbuy Spreadsheet pants and shorts buying guide — discover jeans, trousers, cargo pants, joggers, chinos, and shorts. Measurement guide, fabric tips, fit comparisons, and curated bottom wear finds for 2026." />
      <meta name="keywords" content="superbuy spreadsheet pants, superbuy sheet shorts, superbuy jeans spreadsheet, best superbuy pants, superbuy trousers guide, superbuy spreadsheet joggers, superbuy cargo pants, superbuy chino shorts" />
      <link rel="canonical" href={`${import.meta.env.VITE_SITE_URL || 'https://superbuyspread.makeup'}/superbuy-spreadsheet-pants`} />
      <ArticleLayout slug="superbuy-spreadsheet-pants" />
    </>
  );
}